import axios from "axios";
import { getConfig } from "../config/config";

type TipoConsultaGtins = "GTIN_ORIGEM" | "GTIN_KIT";

interface GetAllGtinsRelacionadosParams {
  gtins: string[];
  confirmar?:boolean;
  tipoConsulta: TipoConsultaGtins;
}

export async function getAllGtinsRelacionados(
  token: string,
  filtros: GetAllGtinsRelacionadosParams
): Promise<{
  success: boolean;
  message: string;
  result: any;
}> {
  try {
    const { gtins, tipoConsulta, confirmar } = filtros;

    if (!gtins || gtins.length === 0) {
      return {
        success: false,
        message: "É obrigatório informar ao menos um GTIN.",
        result: null,
      };
    }
    const gtinParam = `(${gtins.join(",")})`;

    const queryParams = new URLSearchParams();
    queryParams.append("gtin", gtinParam);
    queryParams.append("tipo_consulta", tipoConsulta);
    queryParams.append("confirmar", String(confirmar));


    const response = await axios.get(
      `${getConfig().API_URL}/consultaGtinsRelacionados?${queryParams.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      message: "",
      result: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.message || "Erro desconhecido",
      result: null,
    };
  }
}
